import { render, staticRenderFns } from "./SaleTaxGroups.vue?vue&type=template&id=07e6d261&"
import script from "./SaleTaxGroups.vue?vue&type=script&lang=ts&"
export * from "./SaleTaxGroups.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports